// AdBlocker (uBO 既定の Peter Lowe's list 等) が click.justwatch.com をホストごと止めるブラウザでだけ、
// 配信リンクを r= の遷移先へ差し替える。判定は blockadblock ではなく click.justwatch.com への
// 到達性を直接見る (ABP / Brave は blockadblock に検知されるが click.justwatch.com を止めない)。

const CLICK_HOST = 'click.justwatch.com';
// JustWatch と合意した判定先。クリックとして計上されない (404 を返す)。no-cors なので中身は読めず、届いたかどうかだけが分かる
const PROBE_URL = 'https://click.justwatch.com';
const STORAGE_KEY = 'mal_jw_reachable';
const LINK_SELECTOR = `a[href^="https://${CLICK_HOST}/"]`;
const DIRECT_CLASS = 'jw-direct';

function parseHttpUrl(value) {
  try {
    const url = new URL(value);
    return (url.protocol === 'https:' || url.protocol === 'http:') ? url : null;
  } catch (e) {
    return null;
  }
}

/**
 * JustWatch のクリック URL から遷移先を取り出す。取り出せなければ元の URL を返す。
 * 遷移先が pxf.io (Impact のアフィリエイト追跡) なら、Peter Lowe's list が pxf.io も止めるので u= まで剥がす。
 */
export function unwrap(value) {
  const click = parseHttpUrl(value);
  if (!click || click.hostname !== CLICK_HOST) {
    return value;
  }
  const destination = parseHttpUrl(click.searchParams.get('r'));
  if (!destination) {
    return value;
  }
  if (/(^|\.)pxf\.io$/.test(destination.hostname)) {
    const target = parseHttpUrl(destination.searchParams.get('u'));
    if (target) {
      return target.href;
    }
  }
  return destination.href;
}

function defaultFetch() {
  return typeof window.fetch === 'function' ? window.fetch.bind(window) : null;
}

function defaultStorage() {
  try {
    return window.sessionStorage;
  } catch (e) {
    return null;
  }
}

export function createJustWatchLink({fetchFn = defaultFetch(), storage = defaultStorage()} = {}) {
  let pending = null;

  function readStored() {
    try {
      return storage ? storage.getItem(STORAGE_KEY) : null;
    } catch (e) {
      return null;
    }
  }

  // 失敗は一時的な通信断でも起きるので、届いたときだけ覚える
  function storeReachable() {
    try {
      if (storage) {
        storage.setItem(STORAGE_KEY, '1');
      }
    } catch (e) {
      // private mode 等で書けなければ、次のページで probe し直すだけ
    }
  }

  function probe() {
    if (pending) {
      return pending;
    }
    if (readStored() === '1') {
      pending = Promise.resolve(true);
    } else if (!fetchFn) {
      // 判定できないブラウザではリンクを変えない
      pending = Promise.resolve(true);
    } else {
      pending = fetchFn(PROBE_URL, {mode: 'no-cors', credentials: 'omit', cache: 'no-store'})
        .then(() => true, () => false)
        .then((reachable) => {
          if (reachable) {
            storeReachable();
          }
          return reachable;
        });
    }
    return pending;
  }

  function rewrite(root) {
    Array.prototype.forEach.call(root.querySelectorAll(LINK_SELECTOR), (anchor) => {
      const href = anchor.getAttribute('href');
      const direct = unwrap(href);
      if (direct !== href) {
        anchor.setAttribute('href', direct);
        anchor.classList.add(DIRECT_CLASS);
      }
    });
  }

  function applyIfBlocked(root) {
    return probe().then((reachable) => (reachable ? undefined : rewrite(root)));
  }

  // モーダルにしかリンクが無いページ (ownlist・search 書式のタイル・SP 作品ページ) は、
  // 開かずに去る閲覧が大半なので、開いたとき (modal.js の applyIfBlocked) まで判定しない
  function init(root) {
    if (!root.querySelector(LINK_SELECTOR)) {
      return Promise.resolve();
    }
    return applyIfBlocked(root);
  }

  return {probe, applyIfBlocked, init};
}

export default createJustWatchLink();
